import React from 'react';
import { connect } from 'react-redux';
import {addParamsToUrl} from '../../utils/http';
import {apiUrl} from '../../config';

function mapStateToProps(state) {
	return {
		user : state.session.user,
	}
}

class Home extends React.Component {

	constructor(props) {
		super(props);
		this.getData = this._getData.bind(this);
        this.filterChanged = this._filterChanged.bind(this);
		this.state = {
			territory_id: 0,
			coordination_id: 0,
			user_id: 0,
		}
	}

	_getData() {
        const filters = [
            'territory_id',
            'coordination_id',
            'user_id'
        ];
        return filters.reduce((data, key) => {
            if(this.state[key]) {
                data[key] = this.state[key];
            }
            return data;
        }, {});

    }

	_filterChanged(key, value) {

		const newState = {
			'territory_id': -1,
            'coordination_id': -1,
            'user_id': -1,
		}

		newState[key] = value;

		switch(key) {
			case 'coordination_id':
				newState['territory_id'] = this.state.territory_id;
				break;
			case 'user_id':
				newState['territory_id'] = this.state.territory_id;
				newState['coordination_id'] = this.state.coordination_id;
				break;
			default :
				break;
		}

        console.log('newState', newState);

        const fetchData = {};

        const tmpAnswers = Object.values(newState);
        const keys = Object.keys(newState);
        console.log('tmpAnswers', tmpAnswers);

        tmpAnswers.map((answer, index) => {
            console.log('index', index);
            console.log('answer', answer);

        	if(answer >= 0) {
        		fetchData[keys[index]] = answer;
        	}
        	return false;
        });

                
        console.log('fetchData', fetchData);

        this.setState(newState, () => {
        	console.log('this.state', this.state);
        	this.props.fetchPerformanceReport(fetchData);
        });
    }

	render() {
		const url = `${apiUrl()}/graph`;
		const data = this.props.home.performanceReport ? this.props.home.performanceReport.data : {};
		console.log('data', data);
		const {contacted,visited,done} = data;
		const user = this.props.user;
		const territories = Object.values(this.props.territories.data);
		let coordinations = Object.values(this.props.coordinations.data);

		if(this.state.territory_id !== 0) {
			coordinations = coordinations.filter(coordination => this.state.territory_id === coordination.territory_id);
		}

		const users = this.props.users.data.filter(user => {
			if(user.role !== 'asesor') return false;
			if(this.state.territory_id !== 0) {
				if(user.territory_id !== this.state.territory_id) return false;
			}
			if(this.state.coordination_id !== 0) {
				if(user.coordination_id !== this.state.coordination_id) return false;
			}
			return true;
		});
		if(user) {
			return (
				<div>
					<div className="container">
						<div className="jumbotron text-xs-center">
							<h1 className="display-3">Bienvenido {user.name}</h1>
							<p className="lead">Abra el menú lateral para empezar a navegar</p>
						</div>
					</div>
					<div className="container">
						<div className="row">
							<div className="col">
								<div className="row">
									<div className="col">
										<div className="form-group">
											<label>Territorio</label>
											<select value={this.state.territory_id} className="form-control" onChange={(event) => this.filterChanged('territory_id', parseInt(event.target.value, 10))}>
												<option value={0}>
												Todos los territorios
												</option>
												{
													territories.map(territory => 
														<option key={territory.id} value={territory.id}>
														{territory.name}
														</option>
														)
												}
											</select>
										</div>
									</div>
									<div className="col">
										<div className="form-group">
											<label>Coordinación</label>
											<select value={this.state.coordination_id} className="form-control" onChange={(event) => this.filterChanged('coordination_id', parseInt(event.target.value, 10))}>
												<option value={0}>
												Todas las coordinaciones
												</option>
												{
													coordinations.map(coordination => 
														<option key={coordination.id} value={coordination.id}>
														{coordination.name}
														</option>
														)
												}
											</select>
										</div>
									</div>
									<div className="col">
										<div className="form-group">
											<label>Ejecutivos</label>
											<select value={this.state.user_id} className="form-control" onChange={(event) => this.filterChanged('user_id', parseInt(event.target.value, 10))}>
												<option value={0}>
													Todos los Ejecutivos
												</option>
												{
													users.map(user => 
														<option key={user.id} value={user.id}>
															{user.name}
														</option>
													)
												}
											</select>
										</div>
									</div>
								</div>
								<object id="home-graph-iframe" type="text/html" data={addParamsToUrl(url, data)}></object>
								<div className="row">
									<div className="col">
										<p className="text-center">
											Contactados ({contacted || 0})
											<span className="graph-indicator" style={{backgroundColor : '#f14c62'}}></span>
										</p>
									</div>
									<div className="col">
										<p className="text-center">
											Visitados ({visited || 0})
											<span className="graph-indicator" style={{backgroundColor : '#9e4053'}}></span>
										</p>
									</div>
									<div className="col">
										<p className="text-center">
											Finalizados ({done || 0})
											<span className="graph-indicator" style={{backgroundColor : '#c7c7c7'}}></span>
										</p>
									</div>

									</div>
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div>
					Inicia sesión para empezar a explorar
				</div>
			);
		}
	}
}

export default connect(mapStateToProps)(Home);


/** WEBPACK FOOTER **
 ** ./src/components/presentation/Home.jsx
 **/